import InsectCountLineChartsButton from './InsectCountLineChartsButton';

export default InsectCountLineChartsButton;
